import { useState } from "react";
import './FAQItem.scss';

const FAQItem = ({
    question,
    answer,
    tags,
}) => {
    const [ isOpen, setIsOpen ] = useState(false);
    return (
        <div className="faq-item" data-tags={tags}>
            <h3 className="faq-item-question" style={{cursor: 'pointer'}} onClick={() => setIsOpen(!isOpen)}>
                {question}
                <span className="faq-item-toggle-icon">{isOpen ? '-' : '+'}</span>
            </h3>

            {isOpen && (
                <div className="faq-item-answer">
                    {answer}
                </div>
            )}
        </div>
    )
}

export default FAQItem;